import React from 'react';
import { Link } from 'react-router-dom';
import './css/CategoriesBanner.css';

function CategoriesBanner() {
    return (
        <section className=''>
            <div className="categories-banner ">
                <Link to="/en-individual-selections-courses" className="category-link">Individual</Link>
                <Link to="/en-schools-classes-courses" className="category-link">School</Link>
                <Link to="/en-business-worldwide-courses" className="category-link">Business</Link>
                <Link to="/en-institutions-bacthes-courses" className="category-link">Institutes</Link>
            </div>
        </section>
    );
}

export default CategoriesBanner;
